const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/

export type DateOnlyParts = {
  year: number
  month: number
  day: number
}

export function parseBusinessDateOnly(dateText: string | null | undefined): DateOnlyParts | null {
  if (!dateText) {
    return null
  }

  const trimmed = dateText.trim()
  const match = DATE_ONLY_PATTERN.exec(trimmed)
  if (!match) {
    return null
  }

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])

  if (!Number.isInteger(year) || !Number.isInteger(month) || !Number.isInteger(day)) {
    return null
  }

  if (month < 1 || month > 12 || day < 1 || day > 31) {
    return null
  }

  const utcDate = new Date(Date.UTC(year, month - 1, day))
  if (
    utcDate.getUTCFullYear() !== year ||
    utcDate.getUTCMonth() + 1 !== month ||
    utcDate.getUTCDate() !== day
  ) {
    return null
  }

  return {
    year,
    month,
    day,
  }
}

export function formatSubscriptionBusinessDate(dateText: string | null | undefined, fallback = "N/A"): string {
  const parsed = parseBusinessDateOnly(dateText)
  if (!parsed) {
    return fallback
  }

  const displayDate = new Date(parsed.year, parsed.month - 1, parsed.day)

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(displayDate)
}
